// extracted by mini-css-extract-plugin
export default {"image":"image___ef6dadec95fcc27e","head":"head___f1c70abf5bbb01fc","buttonWrap":"buttonWrap___a652d2cc003e3524","button":"button___cfa84c77fe616bd7"};